/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsageTickerConnectionsSeriesDto } from '../../models/usage-ticker-connections-series-dto';

export interface GetUsageTickerConnectionsSeries$Params {
  from?: string;
  to?: string;
  minutes?: number;
  'X-API-Version'?: string;
}

export function getUsageTickerConnectionsSeries(http: HttpClient, rootUrl: string, params?: GetUsageTickerConnectionsSeries$Params, context?: HttpContext): Observable<StrictHttpResponse<UsageTickerConnectionsSeriesDto>> {
  const rb = new RequestBuilder(rootUrl, getUsageTickerConnectionsSeries.PATH, 'get');
  if (params) {
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('minutes', params.minutes, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UsageTickerConnectionsSeriesDto>;
    })
  );
}

getUsageTickerConnectionsSeries.PATH = '/api/usage-statistics/ticker-connections/series';
